/* eslint-disable react/no-danger */
import React from 'react';

import {
  Paper,
  Avatar,
  Typography,
  Chip,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';


const activityItem = (props) => {
  let reply = null;
  if (props.item.activity_type === 'interests' || props.item.activity_type === 'requests' || props.item.activity_type === 'recommendations') {
    if (props.item.reply && (props.item.reply === 'accept' || props.item.reply.reply === 'accept')) {
      reply = <Chip label="Accepted" className={classes.chip} variant="outlined" />;
    } else if (props.item.reply && (props.item.reply === 'reject' || props.item.reply.reply === 'reject')) {
      reply = <Chip label="Rejected" className={classes.chip} variant="outlined" />;
    } else {
      reply = <Chip label="Reply Pending" className={classes.chip} variant="outlined" />;
    }
  }

  let content = null;

  if (props.item.activity_type !== 'messages') {
    const avatarUrl = constants.BASE_URL + props.item.target_user.avatar;
    let inactive = null;
    if (!props.item.target_user.is_complete) {
      inactive = <Chip label="Profile Inactive" className={classes.chip} variant="outlined" />;
    }
    content = (
      <React.Fragment>
        <Avatar
          src={avatarUrl}
          className={classes.activityListAvatar}
          alt={props.item.target_user.slug}
        />
        <br />
        <Typography variant="subheading">
          {props.item.target_user.first_name} {props.item.target_user.last_name}
        </Typography>
        <Typography variant="body1">{props.item.target_user.profile_id}</Typography>
        {reply}
        {inactive}
      </React.Fragment>
    );
  }

  if (props.item.activity_type === 'messages') {
    content = (
      <div align="left">
        <blockquote className={classes.profileFormQuote}>
          Message:
          <div dangerouslySetInnerHTML={{ __html: props.item.message }} />
        </blockquote>
        <br />
        <Typography>Received: {props.item.created_at}</Typography>
      </div>
    );
  }

  return (
    <Paper className={[classes.card, classes.padding10].join(' ')} align="center">
      {content}
    </Paper>
  );
};

export default activityItem;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityItem.js